import React from "react";
import { getFlagUrl } from "./Utils/getFlagUrl";

const ScratchEliminationPointsMobile = ({ data, rowRange, boldRows, discipline }) => {
  const isSpacer = (row) => row.every((cell) => !cell || cell.trim() === "");

  const isHeaderRow = (row) => {
    const headers = row.map(cell => cell?.toLowerCase().trim());
    return headers.includes("rnk") && headers.includes("last name");
  };

  const renderRiderRow = (row, index) => {
    const rowNumber = rowRange[0] + index + 1;
    const isBold = boldRows.includes(rowNumber);
    const rank = row[0] || "";
    const lastName = row[2] || "";
    const firstName = row[3] || "";
    const country = row[4] || "";
    const totalPoints = row[5] || "";

    const isPointsRace = discipline.toLowerCase().includes("points race");

    return (
      <div key={index} className={`sqm-row ${isBold ? "bold-row" : ""}`}>
        <div className="sqm-rank">{rank}</div>
        <div className="sqm-left">
          <div className="sqm-last-name">{lastName}</div>
          <div className="sqm-first-name">{firstName}</div>
        </div>
        <div className="sqm-right">
          <img src={getFlagUrl(country)} alt={country} className="flag-icon" />
          {isPointsRace && (
            <div className="sqm-time">{totalPoints}</div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className={`mobile-sprint-qualification ${discipline.toLowerCase().includes("points race") ? "points-race" : ""}`}>
      {data.map((row, index) => {
        if (isSpacer(row) || isHeaderRow(row)) return null;
        return renderRiderRow(row, index);
      })}
    </div>
  );
  
};

export default ScratchEliminationPointsMobile;
